import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
// import Services from './pages/Services'
// import Packages from './pages/Packages'
// import Destination from './pages/Destination'
// import Team from './pages/Team'
// import Testimonial from './pages/Testimonial'
import Booking from './pages/Booking'
import Error from './pages/Error'
import Contact from './pages/Contact'
import Certifications from './pages/Certifications'
import Support from './pages/IT_Support'
import WebDev from './pages/WebDev'
import Equipment from './pages/Equipment'
import ProjectManagement from './pages/Project_management'
import Auditing from './pages/Auditing'
import Pricing from './pages/Pricing'

export default function App() {
  return (
    <div>
        <Header />
        <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/about' element={<About/>}/>
        {/* <Route path='/services' element={<Services/>}/>
        <Route path='/packages' element={<Packages/>}/>
        <Route path='/destination' element={<Destination/>}/>
        <Route path='/testimonial' element={<Testimonial/>}/>
        <Route path='/team' element={<Team/>}/> */}
        <Route path='/booking' element={<Booking/>}/>
        <Route path='/error' element={<Error/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/certifications' element={<Certifications/>}/>
        <Route path='/it-Support' element={<Support/>}/>
        <Route path='/web_development' element={<WebDev/>}/>
        <Route path='/equipment_Maintenance' element={<Equipment/>}/>
        <Route path='/project_management' element={<ProjectManagement/>}/>
        <Route path='/auditing' element={<Auditing/>}/>
        <Route path='/pricing' element={<Pricing/>}/>
        </Routes>
        <Footer />
        
    </div>
  )
}
